import { useContext } from 'react';

import { MainLayoutContext } from 'components/templates/MainLayout';

export const useMainLayout = () => {
  const context = useContext(MainLayoutContext);
  return context;
};
